import React from "react";
import { i18n } from "src/common";
import { Text } from "src/components";
import { colors } from "src/theme";
import { Flex } from "../grid";

interface InstallmentProps {
  data: any;
}

const groupPaymentTypesByLargestInstallment = (data: any): any => {
  const groupedPayments: any = {};
  data.forEach((paymentType: any) => {
    const largestInstallment = Math.max(...paymentType.installments.map((i: any) => i.installment));

    if (!groupedPayments[largestInstallment]) {
      groupedPayments[largestInstallment] = [];
    }

    groupedPayments[largestInstallment].push(paymentType.paymentTypeLabel);
  });

  return groupedPayments;
};

export const Installments: React.FC<InstallmentProps> = ({ data }) => {
  const { paymentOptions } = data;
  const find = paymentOptions.find((el: { paymentOption: string; }) => el.paymentOption === 'creditCardWithInstallments');
  const grouped = find ? groupPaymentTypesByLargestInstallment(find.paymentTypes) : {};
  return (
    <Flex vertical gap={8}>
      {Object.keys(grouped).reverse().map((key: string, index: number) => <Text type='small' color={colors.text2} key={index}>
        {`${i18n.t("pages.checkoutPage.installmentUntil", { count: parseInt(key, 10) })} ${grouped[key].join(", ")}`}
      </Text>)
      }
    </Flex>
  )
}